import React, { useContext, useState } from "react";
import { useHistory } from "react-router";
import { PermissionContext, RolePermissions } from "appContext";
import { ReactComponent as MoneyIcon } from "assets/img/svg/MoneyWavyGreen.svg";
import { ReactComponent as CashRefund } from "assets/img/svg/Group 30.svg";
import { getScreenCards } from "views/pages/manage/finOps/IssueStock/search/SearchCard";
import { pages } from "views/pages/manage/common/constant";

const ModuleCards = ({ }) => {
  const history = useHistory();

  const CompletionRefundControlPermission = RolePermissions(
    useContext(PermissionContext),
    pages["completionRefundControl"]["id"]
  );
  const WithdrawlPermission = RolePermissions(
    useContext(PermissionContext),
    pages["withdrawlCalculationConfig"]["id"]
  );
  const ApprovalConfigPermissions = RolePermissions(
    useContext(PermissionContext),
    pages["refundApprovalConfig"]["id"]
  );

  const cards = [
    ...(CompletionRefundControlPermission.length
      ? [{
        heading: "Completion refund control",
        subHeading:
          "BU level config for completion refunds",
        icon: <MoneyIcon />,
        action: () => {
          history.push("/admin/refundSetup/completionRefundControl");
        },
      }] : []),

    ...(ApprovalConfigPermissions ? [{
      heading: "Refunds approval config",
      subHeading: "Modify roles and access for refund approvals",
      icon: <CashRefund />,
      action: () => {
        history.push("/admin/refundSetup/refundsApprovalConfig");
      }
    }] : []),

    ...(WithdrawlPermission.length ? [{
      heading: "Week wise calculation logic",
      subHeading: "Setup week wise logic",
      icon: <CashRefund />,
      action: () => {
        history.push("/admin/refundSetup/weekWise");
      },
    }] : []),
  ]
  return (
    <>
      <div className={`screen-cards-container`}>{getScreenCards(cards)}</div>
    </>
  );
};

export default ModuleCards;
